import { EventParams } from './AnalyticsTypes';
import PrescriptionModelReference, {
  Identifier,
} from '../../model/prescription/PrescriptionModelReference';

export const ANALYTICS_EVENTS = {
  seedingPrescriptionCreated: (
    jobId: string | number,
    usedCalculator: boolean,
    prescriptionModel: PrescriptionModelReference | null
  ) => {
    const usedMultiLayerStrategy =
      prescriptionModel?.identifier === Identifier.MultiLayerSeedingModel;

    return {
      eventname: 'seeding_prescription_created',
      eventparams: {
        job_id: jobId,
        used_calculator: usedCalculator,
        used_multi_layer_strategy: usedMultiLayerStrategy,
        creation_method: usedCalculator
          ? usedMultiLayerStrategy
            ? 'both'
            : 'calculator_only'
          : usedMultiLayerStrategy
            ? 'multi_layer_only'
            : 'neither',
        ...(prescriptionModel && {
          prescription_model_identifier: prescriptionModel.identifier,
          prescription_model_version: prescriptionModel.version,
        }),
      } as EventParams,
    };
  },

  button: (buttonName: string, extraParams?: EventParams) => ({
    eventname: `${buttonName}_clicked`,
    eventparams: {
      button_name: buttonName,
      ...extraParams,
    } as EventParams,
  }),

  textField: (fieldName: string, extraParams?: EventParams) => ({
    eventname: `${fieldName}_changed`,
    eventparams: {
      field_name: fieldName,
      ...extraParams,
    } as EventParams,
  }),

  checkbox: (checkboxName: string, extraParams?: EventParams) => ({
    eventname: `${checkboxName}_checked`,
    eventparams: {
      checkbox_name: checkboxName,
      ...extraParams,
    } as EventParams,
  }),

  toggle: (toggleName: string, extraParams?: EventParams) => ({
    eventname: `${toggleName}_toggled`,
    eventparams: {
      toggle_name: toggleName,
      ...extraParams,
    } as EventParams,
  }),

  link: (linkName: string, extraParams?: EventParams) => ({
    eventname: `${linkName}_clicked`,
    eventparams: {
      link_name: linkName,
      ...extraParams,
    } as EventParams,
  }),

  selector: (elementName: string, extraParams?: EventParams) => ({
    eventname: `${elementName}_selected`,
    eventparams: {
      button_name: elementName,
      ...extraParams,
    } as EventParams,
  }),
};
